import React, { useState, useEffect } from "react";

import MenuApi from "../../../../App/api/menu.apis";
import Select from "react-select";
import selectDropdown from "../../../../custom/SelectDropdown";
import { Form, Formik } from "formik";
import Toggle from "../../../../Components/Common/Toggle";
import Styles from "./Styles.module.css";
import { useSelector } from "react-redux";
import GradientButton from "../../../../Components/Button/GradientButton";
import * as Yup from "yup";
import { toast } from "react-toastify";

function CountryModal({
  selectedCountry,

  setDeliveries,
  onAddCountry,
  resetForm,
  handleAddButton,
  setSelectedCountry,
}) {
  console.log(" selected country is coming :", selectedCountry);

  const { theme } = useSelector((state) => state.theme);

  const countryList = useSelector((state) => state.country.data);
  const options = selectDropdown(countryList, "_id", "name");
  const [selectedOption, setSelectedOption] = useState();
  const [cityData, setCityData] = useState();

  const initialFormValues = {
    country: selectedCountry?.country?._id || "",
    currency: selectedCountry?.currency || "",
    nativeSymbol: selectedCountry?.nativeSymbol || "",
    symbol: selectedCountry?.symbol || "",
    stripeAmount: selectedCountry?.stripeAmount || "",
    autoTransferDayForDeliveryman:
      selectedCountry?.autoTransferDayForDeliveryman || false,
    autoTransferDeliverymanValue:
      selectedCountry?.autoTransferDeliverymanValue || "",
    autoTransferDayForStore: selectedCountry?.autoTransferDayForStore || false,
    autoTransferDayStoreValue: selectedCountry?.autoTransferDayStoreValue || "",
    business: selectedCountry?.business || false,
    showAds: selectedCountry?.showAds || false,
    sendMoneyForUser: selectedCountry?.sendMoneyForUser || false,
    sendMoneyForVendor: selectedCountry?.sendMoneyForVendor || false,
    sendMoneyForDeliveryman: selectedCountry?.sendMoneyForDeliveryman || false,
    referralForUser: selectedCountry?.referralForUser || false,
    userCodeLimit: selectedCountry?.userCodeLimit || "",
    bonusToUser: selectedCountry?.bonusToUser || "",
    bonusToUserFriend: selectedCountry?.bonusToUserFriend || "",
    referralForDeliveryman: selectedCountry?.referralForDeliveryman || false,
    deliverymanCodeLimit: selectedCountry?.deliverymanCodeLimit || "",
    bonusToDeliveryman: selectedCountry?.bonusToDeliveryman || "",
    bonusToDeliverymanFriend: selectedCountry?.bonusToDeliverymanFriend || "",
    referralForStore: selectedCountry?.referralForStore || false,
    storeCodeLimit: selectedCountry?.storeCodeLimit || "",
    bonusToStore: selectedCountry?.bonusToStore || "",
    bonusToStoreFriend: selectedCountry?.bonusToStoreFriend || "",
  };

  const validate = Yup.object({
    country: Yup.string().required("Country is required"),
    currency: Yup.string().required("Currency code is required"),
  });

  const handleCountry = async (selected, setFieldValue) => {
    try {
      if (selected) {
        const countryResponse = await MenuApi.getAllCountry(selected.value);
        const finalData = countryResponse.data.data.find(
          (country) => country._id === selected.value
        );

        setFieldValue("country", finalData?._id);
        setFieldValue("currency", finalData?.currency || "");
        setFieldValue("nativeSymbol", finalData?.symbolNative || "");
        setFieldValue("symbol", finalData?.symbol || "");

        const cityResponse = await MenuApi.getAllCity(selected.value);
      }
    } catch (error) {
      console.error("Error fetching country details:", error);
      toast.error("Error fetching country details");
    }
  };

  const handleChange = (event, setFieldValue) => {
    const { name, type, value, checked } = event.target;
    setFieldValue(name, type === "checkbox" ? checked : value);
  };

  const handleSubmit = async (values) => {
    try {
      const response = selectedCountry
        ? await MenuApi.updateCountryInfo(selectedCountry._id, values)
        : await MenuApi.createCountryInfo(values);

      onAddCountry(response.data);
      setDeliveries((prevDeliveries) => [...prevDeliveries, response.data]);

      toast.success(
        selectedCountry
          ? "Country details updated successfully!"
          : "New Country Details Created Successfully!"
      );
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An error occurred while saving country details.");
    }
  };

  return (
    <Formik
      initialValues={initialFormValues}
      validationSchema={validate}
      onSubmit={handleSubmit}
      enableReinitialize={true}
    >
      {({ values, isSubmitting, setFieldValue, errors, touched }) => (
        <Form>
          <div
            className={`p-10 container mx-auto px-4 shadow-xl rounded-md ${
              theme === "light"
                ? "hover:bg-[#f8f8f8]"
                : "hover:bg-thirsaryColor"
            }`}
          >
            <div className="flex pb-5 gap-x-20 ">
              <div className="">
                <div>
                  <h1 className={Styles.text_head}>Basic details</h1>
                  <hr />

                  <div className={Styles.column_cont}>
                    {/* country */}
                    <div className={Styles.bundle}>
                      <label className={Styles.txt_lbl}>country</label>

                      <Select
                        value={
                          selectedCountry?.country?.name ||
                          (values.country &&
                            options.find((c) => values.country === c._id))
                        }
                        name="country"
                        placeholder={
                          selectedCountry?.country?.name || "Select country"
                        }
                        options={options}
                        onChange={(selected) =>
                          handleCountry(selected, setFieldValue)
                        }
                        className="w-3/4 font-bold text-base text-capitalize bg-transparent"
                      />
                      {errors.country && touched.country && (
                        <div className="text-red-500 text-sm mt-1">
                          {errors.country}
                        </div>
                      )}

                      {/* <input
                        type="text"
                        className="w-3/4 font-bold text-base  border-2 border-solid p-2 outline-none bg-transparent"
                        placeholder=" Country Name "
                        value={selectedCountry?.name || ""}
                        readOnly
                      /> */}
                    </div>

                    <div className={Styles.bundle}>
                      <label className={Styles.txt_lbl}>currency</label>
                      <div className="flex flex-row">
                        <input
                          name="currency"
                          type="text"
                          className="w-1/5 font-bold text-base  border-2 /border-solid p-2 ml-1  outline-none bg-transparent"
                          placeholder="CC"
                          value={values.currency}
                          readOnly
                        />
                        <input
                          type="text"
                          className="w-14 font-bold text-base  border-2 border-solid p-2 ml-1 outline-none bg-transparent"
                          placeholder=" SN"
                          value={values.nativeSymbol}
                          readOnly
                        />

                        <input
                          type="text"
                          className="w-14 font-bold text-base  border-2 /border-solid p-2 ml-1  outline-none bg-transparent"
                          placeholder="S"
                          value={values?.symbol}
                          readOnly
                        />
                      </div>
                      {errors.currency && touched.currency && (
                        <div className="text-red-500 text-sm mt-1">
                          {errors.currency}
                        </div>
                      )}
                      <p className={Styles.text_1}>
                        enter sign we will show everywhere on apps
                      </p>
                    </div>
                  </div>

                  {/* auto transfer day for deliveryman */}
                  <div className={Styles.bundle}>
                    <div className="mt-5">
                      <span className="mb-2">
                        <Toggle
                          value={values.autoTransferDayForDeliveryman}
                          onChange={({ target: { checked } }) => {
                            setFieldValue(
                              "autoTransferDayForDeliveryman",
                              checked
                            );

                            if (!checked) {
                              setFieldValue("autoTransferDeliverymanValue", "");
                            }
                          }}
                        />
                      </span>
                      <label className={Styles.txt_lbl}>
                        auto transfer day for deliveryman
                      </label>
                    </div>
                    <input
                      placeholder="ATD for deliveryman"
                      className="w-3/4 h-10 bg-grey-800 border-2 border-solid text-base  pl-2 capitalize outline-none bg-transparent"
                      name="autoTransferDeliverymanValue"
                      value={values.autoTransferDeliverymanValue || ""}
                      onChange={(event) => handleChange(event, setFieldValue)}
                      disabled={!values.autoTransferDayForDeliveryman}
                    />
                    <p className={Styles.text_1}>
                      stripe amount we will send on above day
                    </p>
                  </div>

                  {/* auto transfer day for store */}
                  <div className={Styles.bundle}>
                    <div>
                      <Toggle
                        value={values.autoTransferDayForStore}
                        onChange={({ target: { checked } }) => {
                          setFieldValue("autoTransferDayForStore", checked);

                          if (!checked) {
                            setFieldValue("autoTransferDayStoreValue", "");
                          }
                        }}
                      />
                      <label className={Styles.txt_lbl}>
                        auto transfer day for store{" "}
                      </label>
                    </div>
                    <input
                      type="text"
                      placeholder="ATD for store"
                      name="autoTransferDayStoreValue"
                      value={values.autoTransferDayStoreValue || ""}
                      onChange={(event) => handleChange(event, setFieldValue)}
                      disabled={!values.autoTransferDayForStore}
                      className="w-3/4 h-10 bg-grey-500 border-2 border-solid text-base  pl-2 capitalize outline-none bg-transparent"
                    />
                    <p className={Styles.text_1}>
                      stripe amount we will send on above day
                    </p>
                  </div>

                  <hr className="" />

                  <div className={Styles.column_cont}>
                    {/* business option */}
                    <div className={Styles.bundle}>
                      <div>
                        <Toggle
                          value={values.business}
                          onChange={() =>
                            setFieldValue("business", !values.business)
                          }
                          disabled
                        />
                        <label className={Styles.txt_lbl}>Business</label>
                      </div>
                    </div>

                    {/* distance unit in mile */}
                    {/* <div className={Styles.bundle}>
                    <div>
                      <Toggle />
                      <label className={Styles.txt_lbl}>
                        distance unit in mile ?
                      </label>
                    </div>
                    <p className={Styles.text_1}>
                      if on and any ads available then it will send on user side
                    </p>
                  </div> */}

                    {/* show ads option */}
                    <div className={Styles.bundle}>
                      <div>
                        <Toggle
                          value={values.showAds}
                          onChange={() =>
                            setFieldValue("showAds", !values.showAds)
                          }
                          disabled
                        />
                        <label className={Styles.txt_lbl}>show ads</label>
                      </div>
                      <p className={Styles.text_1}>
                        if on and any ads available then it will send on user
                        side
                      </p>
                    </div>
                  </div>
                  <hr className="" />

                  <div className={Styles.column_cont}>
                    {/* send money to friend category */}
                    <h1 className={Styles.text_head}>Send Money to friend </h1>
                    <div className={Styles.bundle}>
                      <div>
                        <Toggle
                          value={values.sendMoneyForUser}
                          onChange={() =>
                            setFieldValue(
                              "sendMoneyForUser",
                              !values.sendMoneyForUser
                            )
                          }
                          disabled
                        />
                        <label className={Styles.txt_lbl}>
                          send money for User
                        </label>
                      </div>
                    </div>

                    <div className={Styles.bundle}>
                      <div>
                        <Toggle
                          value={values.sendMoneyForVendor}
                          onChange={() =>
                            setFieldValue(
                              "sendMoneyForVendor",
                              !values.sendMoneyForVendor
                            )
                          }
                          disabled
                        />
                        <label className={Styles.txt_lbl}>
                          send money for Vendor
                        </label>
                      </div>
                    </div>

                    <div className={Styles.bundle}>
                      <div>
                        <Toggle
                          value={values.sendMoneyForDeliveryman}
                          onChange={() =>
                            setFieldValue(
                              "sendMoneyForDeliveryman",
                              !values.sendMoneyForDeliveryman
                            )
                          }
                          disabled
                        />
                        <label className={Styles.txt_lbl}>
                          send money for Deliveryman
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* referral settings */}

              {/* referral for user */}
              <div className="flex flex-column">
                <h1 className={Styles.text_head}>Referral settings</h1>
                <hr />
                <div className={Styles.column_cont}>
                  <div className={Styles.bundle}>
                    <div>
                      <Toggle
                        value={values.referralForUser}
                        onChange={({ target: { checked } }) => {
                          setFieldValue("referralForUser", checked);

                          if (!checked) {
                            setFieldValue("userCodeLimit", "");
                            setFieldValue("bonusToUser", "");
                            setFieldValue("bonusToUserFriend", "");
                          }
                        }}
                      />
                      <label className={Styles.txt_lbl}>
                        referral for user
                      </label>
                    </div>
                  </div>

                  <div className={Styles.bundle}>
                    <div className="flex flex-row border-gray-500 border-solid w-100  ">
                      <input
                        type="text"
                        placeholder="No of user use code"
                        className="w-30 h-10  border-2 bg-transparent border-solid text-md  pl-2 capitalize outline-none"
                        name="userCodeLimit"
                        value={values.userCodeLimit}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForUser}
                      />
                      <input
                        type="text"
                        placeholder="100"
                        className="w-10 h-10 bg-grey-500 border-2 border-solid outline-none bg-transparent text-md "
                        name="stripeAmount"
                        value={values.stripeAmount}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForUser}
                      />
                    </div>
                    <p className={Styles.text_1}>
                      user no of friend can use referral code (Max 10 digits)
                    </p>
                  </div>

                  <div className={Styles.bundle}>
                    <div className="flex flex-row border-gray-500 border-solid w-100 ">
                      <input
                        type="text"
                        placeholder="bonus to user"
                        className="w-30 h-10 bg-grey-500 border-2 border-solid tex-lg pl-2 capitalize outline-none bg-transparent text-md"
                        name="bonusToUser"
                        value={values.bonusToUser}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForUser}
                      />
                      <input
                        className="w-10 h-10 bg-grey-500 border-2 border-solid pl-3 text-lg outline-none bg-transparent text-md"
                        type="text"
                        placeholder="₹"
                        disabled={!values.referralForUser}
                      />
                      <input
                        className="w-10 h-10 bg-grey-500 border-2 border-solid pl-2 outline-none bg-transparent text-md"
                        type="text"
                        placeholder="100"
                        name="stripeAmount"
                        value={values.stripeAmount}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForUser}
                      />
                    </div>
                    <p className={Styles.text_1}>
                      bonus will add on user wallet
                    </p>
                  </div>

                  <div className={Styles.bundle}>
                    <div className="flex flex-row border-gray-500 border-solid w-100 ">
                      <input
                        type="text"
                        placeholder="bonus to user's friends"
                        className="w-30 h-10 bg-grey-500 border-2 border-solid tex-lg pl-2 capitalize outline-none bg-transparent text-md"
                        name="bonusToUserFriend"
                        value={values.bonusToUserFriend}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForUser}
                      />
                      <input
                        className="w-10 h-10 bg-grey-500 border-2 border-solid pl-3 text-lg outline-none bg-transparent text-md"
                        type="text"
                        placeholder="₹"
                        disabled={!values.referralForUser}
                      />
                      <input
                        className="w-10 h-10 bg-grey-500 border-2 border-solid pl-2 outline-none bg-transparent text-md"
                        type="text"
                        placeholder="100"
                        name="stripeAmount"
                        value={values.stripeAmount}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForUser}
                      />
                    </div>
                    <p className={Styles.text_1}>
                      bonus will add on user friend wallet
                    </p>
                  </div>
                </div>
                <hr className="" />

                {/* Referral for Deliveryman */}
                <div className={Styles.column_cont}>
                  <div className={Styles.bundle}>
                    <div className="flex items-center">
                      <Toggle
                        value={values.referralForDeliveryman}
                        onChange={({ target: { checked } }) => {
                          setFieldValue("referralForDeliveryman", checked);

                          if (!checked) {
                            setFieldValue("deliverymanCodeLimit", "");
                            setFieldValue("bonusToDeliveryman", "");
                            setFieldValue("bonusToDeliverymanFriend", "");
                          }
                        }}
                      />
                      <label className={Styles.txt_lbl}>
                        Referral for Deliveryman
                      </label>
                    </div>
                  </div>

                  <div className={Styles.bundle}>
                    <div className="flex border-gray-500 border-solid w-full">
                      <input
                        type="text"
                        placeholder="No of Deliveryman Use Code"
                        className="w-60 h-10 bg-gray-100 border-2 border-solid pl-2 capitalize outline-none text-md"
                        name="deliverymanCodeLimit"
                        value={values.deliverymanCodeLimit}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForDeliveryman}
                      />
                      <input
                        className="w-16 h-10 bg-gray-100 border-2 border-solid pl-2 text-md outline-none text-center"
                        type="text"
                        placeholder="100"
                        name="stripeAmount"
                        value={values.stripeAmount}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForDeliveryman}
                      />
                    </div>
                    <p className={Styles.text_1}>
                      User no of friend can use referral code (Max 10 digits)
                    </p>
                  </div>

                  <div className={Styles.bundle}>
                    <div className="flex border-gray-500 border-solid w-full">
                      <input
                        type="text"
                        placeholder="Bonus to Delivery Man"
                        className="w-48 h-10 bg-gray-100 border-2 border-solid pl-2 capitalize outline-none text-md"
                        name="bonusToDeliveryman"
                        value={values.bonusToDeliveryman}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForDeliveryman}
                      />
                      <input
                        className="w-10 h-10 bg-gray-100 border-2 border-solid pl-3 text-lg outline-none text-center"
                        type="text"
                        placeholder="₹"
                        disabled={!values.referralForDeliveryman}
                      />
                      <input
                        className="w-16 h-10 bg-gray-100 border-2 border-solid pl-2 outline-none text-md text-center"
                        type="text"
                        placeholder="100"
                        name="stripeAmount"
                        value={values.stripeAmount}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForDeliveryman}
                      />
                    </div>
                    <p className={Styles.text_1}>
                      Bonus will add on user wallet
                    </p>
                  </div>

                  <div className={Styles.bundle}>
                    <div className="flex border-gray-500 border-solid w-full">
                      <input
                        type="text"
                        placeholder="Bonus to Delivery Man's Friend"
                        className="w-48 h-10 bg-gray-100 border-2 border-solid pl-2 capitalize outline-none text-md"
                        name="bonusToDeliverymanFriend"
                        value={values.bonusToDeliverymanFriend}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForDeliveryman}
                      />
                      <input
                        className="w-10 h-10 bg-gray-100 border-2 border-solid pl-3 text-lg outline-none text-center"
                        type="text"
                        placeholder="₹"
                        disabled={!values.referralForDeliveryman}
                      />
                      <input
                        className="w-16 h-10 bg-gray-100 border-2 border-solid pl-2 outline-none text-md text-center"
                        type="text"
                        placeholder="100"
                        name="stripeAmount"
                        value={values.stripeAmount}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForDeliveryman}
                      />
                    </div>
                    <p className={Styles.text_1}>
                      Bonus will add on user friend wallet
                    </p>
                  </div>
                </div>

                <hr className="" />
                {/* referral for store */}
                <div className={Styles.column_cont}>
                  <div className={Styles.bundle}>
                    <div>
                      <Toggle
                        value={values.referralForStore}
                        onChange={({ target: { checked } }) => {
                          setFieldValue("referralForStore", checked);

                          if (!checked) {
                            setFieldValue("storeCodeLimit", "");
                            setFieldValue("bonusToStore", "");
                            setFieldValue("bonusToStoreFriend", "");
                          }
                        }}
                      />
                      <label className={Styles.txt_lbl}>
                        referral for store
                      </label>
                    </div>
                  </div>

                  <div className={Styles.bundle}>
                    <div className="flex flex-row border-gray-500 border-solid w-100 ">
                      <input
                        type="text"
                        placeholder="no of store use code "
                        className="w-60 h-10 bg-grey-500 border-2 border-solid tex-lg pl-2 capitalize outline-none bg-transparent text-md"
                        name="storeCodeLimit"
                        value={values.storeCodeLimit}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForStore}
                      />
                      <input
                        className="w-10 h-10 bg-grey-500 border-2 border-solid pl-2 outline-none bg-transparent text-md"
                        type="text"
                        placeholder="100"
                        name="stripeAmount"
                        value={values.stripeAmount}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForStore}
                      />
                    </div>
                    <p className={Styles.text_1}>
                      user no of friend can use referral code (Max 10 digits)
                    </p>
                  </div>

                  <div className={Styles.bundle}>
                    <div className="flex flex-row border-gray-500 border-solid w-100 ">
                      <input
                        type="text"
                        placeholder="bonus to store"
                        className="w-60 h-10 bg-grey-500 border-2 border-solid tex-lg pl-2 capitalize outline-none bg-transparent text-md"
                        name="bonusToStore"
                        value={values.bonusToStore}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForStore}
                      />
                      <input
                        className="w-10 h-10 bg-grey-500 border-2 border-solid pl-3 text-lg  outline-none bg-transparent text-md"
                        type="text"
                        placeholder="₹"
                        disabled={!values.referralForStore}
                      />
                      <input
                        className="w-10 h-10 bg-grey-500 border-2 border-solid pl-2 outline-none bg-transparent text-md"
                        type="text"
                        placeholderue="100"
                        name="stripeAmount"
                        value={values.stripeAmount}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForStore}
                      />
                    </div>
                    <p className={Styles.text_1}>
                      bonus will add on user wallet
                    </p>
                  </div>

                  <div className={Styles.bundle}>
                    <div className="flex flex-row border-gray-500 border-solid w-100 ">
                      <input
                        type="text"
                        placeholder="bonus to store's friend "
                        className="w-60 h-10 bg-grey-500 border-2 border-solid tex-lg pl-2 capitalize outline-none bg-transparent text-md"
                        name="bonusToStoreFriend"
                        value={values.bonusToStoreFriend}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForStore}
                      />
                      <input
                        className="w-10 h-10 bg-grey-500 border-2 border-solid pl-3 text-lg outline-none bg-transparent text-md"
                        type="text"
                        placeholder="₹"
                        disabled={!values.referralForStore}
                      />
                      <input
                        className="w-10 h-10 bg-grey-500 border-2 border-solid pl-2 outline-none bg-transparent text-md"
                        type="text"
                        placeholder="100"
                        name="stripeAmount"
                        value={values.stripeAmount}
                        onChange={(event) => handleChange(event, setFieldValue)}
                        disabled={!values.referralForStore}
                      />
                    </div>
                    <p className={Styles.text_1}>
                      bonus will add on user friend wallet
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Conditional Button Rendering for add and update*/}
            <div className="flex flex-row ml-[30%]   p-2">
              <GradientButton
                type="submit"
                label={selectedCountry ? "Update" : "Submit"}
                disabled={isSubmitting}
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default CountryModal;
